import axios from "axios";
import { useAppStore } from "../zustand/useAppStore";


//const API_URL = 'https://admin.ustathi.app/Api/';

//const API_URL = 'http://localhost/future-erp/Api/';
  
  const API_URL = 'https://financial.dawasmart.com/Api/';

function getDeviceId() {
    let deviceId = localStorage.getItem('unique_device_id');
    if (!deviceId) {
        // Generate a new UUID if one doesn't exist
        deviceId = generateDeviceId(); // Use the built-in Crypto API
        localStorage.setItem('unique_device_id', deviceId);
    }
    return deviceId;
}

const generateDeviceId = () => {
  // If the modern Crypto API is available, use it
  if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  
  // Standard pseudorandom math fallback for non-secure HTTP testing environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};









export const axiosInstance = axios.create({
  baseURL:  API_URL,
  withCredentials: true,

});

export const axiosUpload = axios.create({
  baseURL:  API_URL,
});



axiosUpload.interceptors.request.use(async (config) => {
  try {
    const { token } = useAppStore.getState();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Check if the data being sent is an instance of FormData
    if (config.data instanceof FormData) {
      // DELETE the content-type header
      // This allows Axios/Browser to automatically set it to multipart/form-data
      // with the correct boundary string.
      delete config.headers['Content-Type'];
    } else {
      // Default to JSON for standard POST/UPDATE requests
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  } catch (error) {
    return config;
  }
});